import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, from, switchMap, catchError} from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.url.includes(environment.aodocsBaseUrl) || req.url.includes(environment.backendHost)) {
    const authService: AuthService = inject(AuthService);

    // Handle the Promise-based token retrieval
    return from(authService.getToken().catch(error => {
      console.error('Failed to get authentication token:', error);
      return null;
    })).pipe(
      switchMap(token => {
        if (token) {
          // Clone the request with the token
          const authReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`),
          });
          return next(authReq);
        } else {
          // Proceed without the token if not available
          return next(req);
        }
      }),
      catchError(error => {
        console.error('Error in auth interceptor:', error);
        return next(req);
      })
    );
  }

  // For requests that don't need authentication
  return next(req);
}
